/* Plan selector.
 *
 * The cards are chrome; these are the mechanics behind them.
 *   - clicking a card sets the hidden `selling_plan` input, which the cart-add
 *     code in global.js already reads, so one-time posts an empty value and the
 *     two subscription cards post their plan id
 *   - it also pins the hidden `id` input to the card's own variant, because all
 *     three cards are selling plans on ONE variant
 *   - it writes the selected card's price onto the add-to-cart button, so the
 *     button states the figure it is about to charge
 *   - the annual card reveals a consent checkbox and blocks add-to-cart until it
 *     is ticked, then stamps a visible line-item property onto the order so the
 *     acceptance is recorded against the order itself, not just in the browser
 *
 * Card clicks are handled in the capture phase and stopped here.  Two older
 * mechanisms in the theme assume one card per variant: a document-level handler
 * in global.js that reads a click on the already-active card as "add to cart"
 * (and, since every card here carries the same data-variant-id, read *every*
 * click as that), and a bridge that mapped card position onto the nth variant.
 * Letting clicks through to either one put the wrong product in the cart.
 */
(function () {
  function init() {
    var box = document.querySelector('.custom-variant-box[data-plan-box]');
    if (!box) return;

    var form = box.closest('form');
    if (!form) return;

    var planInput = form.querySelector('[data-selling-plan-input]');
    var idInput = form.querySelector('input[name="id"]');
    var consent = form.querySelector('[data-annual-consent]');
    var consentBox = consent ? consent.querySelector('input[type="checkbox"]') : null;
    var consentProp = form.querySelector('[data-consent-prop]');
    var submit = form.querySelector('.product-form__submit');
    var atcPrice = form.querySelector('[data-atc-price]');
    var cards = [].slice.call(box.querySelectorAll('.variant-card'));

    function activeCard() {
      return box.querySelector('.variant-card.active') || cards[0];
    }

    function isAnnual(card) {
      return !!(card && card.getAttribute('data-plan-term') === 'annual');
    }

    function sync() {
      var card = activeCard();
      if (planInput) planInput.value = card ? (card.getAttribute('data-selling-plan') || '') : '';

      /* pin the variant: nothing else on the page is allowed to move it */
      var vid = card && card.getAttribute('data-variant-id');
      if (idInput && vid) idInput.value = vid;

      /* The add-to-cart button states the price of the selected plan. The figures
         are read off the card rather than recomputed, so the button and the card
         cannot drift, and Shopify Markets currency comes through untouched. */
      if (atcPrice) {
        var now = card && card.querySelector('.discounted_price');
        var was = card && card.querySelector('.original_price');
        var nowTxt = now ? (now.textContent || '').trim() : '';
        var wasTxt = was ? (was.textContent || '').trim() : '';
        if (nowTxt) {
          var html = '<span class="atc__sep">\u00B7</span>';
          if (wasTxt && wasTxt !== nowTxt) html += '<s></s>';
          html += '<b></b>';
          atcPrice.innerHTML = html;
          var sEl = atcPrice.querySelector('s');
          if (sEl) sEl.textContent = wasTxt;
          atcPrice.querySelector('b').textContent = nowTxt;
          atcPrice.hidden = false;
        } else {
          atcPrice.hidden = true;
          atcPrice.textContent = '';
        }
      }

      var needsConsent = isAnnual(card);
      if (consent) consent.hidden = !needsConsent;

      var blocked = needsConsent && consentBox && !consentBox.checked;
      if (submit) {
        submit.disabled = !!blocked;
        submit.setAttribute('aria-disabled', blocked ? 'true' : 'false');
      }
      if (consentProp) {
        consentProp.value = (needsConsent && consentBox && consentBox.checked)
          ? new Date().toISOString().replace(/\.\d+Z$/, 'Z')
          : '';
      }
    }

    function select(card) {
      cards.forEach(function (c) { c.classList.remove('active'); });
      card.classList.add('active');
      sync();
    }

    function cardFrom(target) {
      if (!target || !target.closest) return null;
      var card = target.closest('.variant-card');
      return card && box.contains(card) ? card : null;
    }

    box.addEventListener('click', function (e) {
      var card = cardFrom(e.target);
      if (!card) return;          /* consent checkbox and its links fall through */
      e.stopPropagation();
      select(card);
    }, true);

    box.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var card = cardFrom(e.target);
      if (!card) return;
      e.stopPropagation();
      e.preventDefault();
      select(card);
    }, true);

    if (consentBox) consentBox.addEventListener('change', sync);

    /* the active class is toggled by other scripts too, so watch for it */
    new MutationObserver(function () { sync(); })
      .observe(box, { subtree: true, attributes: true, attributeFilter: ['class'] });

    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
